export type PatientMessageComposeChannel = 'messages' | 'sms';

export type PatientMessageComposeFacts = {
  channel: PatientMessageComposeChannel;
  patientSelected: boolean;
  detailsReady: boolean;
  detailsError: boolean;
  hasEmail: boolean;
  hasPortalAccess: boolean;
  portalInvitePending: boolean;
  inviteResolved: boolean;
  patientActive: boolean;
};

export type PatientMessageComposeNotice =
  | { kind: 'sms' }
  | { kind: 'pick_patient' }
  | { kind: 'loading' }
  | { kind: 'unconfirmed' }
  | { kind: 'portal_and_email' }
  | { kind: 'portal_no_email' }
  | { kind: 'email_no_portal'; offerInvite: boolean }
  | { kind: 'email_no_portal_pending' }
  | { kind: 'neither' };

export function patientMessageComposeNotice(
  facts: PatientMessageComposeFacts,
): PatientMessageComposeNotice {
  if (facts.channel === 'sms') return { kind: 'sms' };
  if (!facts.patientSelected) return { kind: 'pick_patient' };
  if (facts.detailsError) return { kind: 'unconfirmed' };
  if (!facts.detailsReady) return { kind: 'loading' };
  if (facts.hasPortalAccess && facts.hasEmail) return { kind: 'portal_and_email' };
  if (facts.hasPortalAccess) return { kind: 'portal_no_email' };
  if (facts.hasEmail) {
    if (facts.inviteResolved && facts.portalInvitePending) {
      return { kind: 'email_no_portal_pending' };
    }
    return {
      kind: 'email_no_portal',
      offerInvite: facts.inviteResolved && facts.patientActive,
    };
  }
  return { kind: 'neither' };
}
